module.exports = __webpack_public_path__ + "media/common/images/cta/zak-3619e52a934ed9b4e659ce22ce5d3884.jpeg";